function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export function transformExpoContactToMyStoryMyPlanContact(contact) {
    var _contact_phoneNumbers_, _contact_phoneNumbers;
    var hasNameParts = !!(contact.firstName || contact.lastName);
    var _contact_firstName, _contact_lastName, _contact_name;
    var nameFields = hasNameParts ? {
        firstName: (_contact_firstName = contact.firstName) !== null && _contact_firstName !== void 0 ? _contact_firstName : '',
        lastName: (_contact_lastName = contact.lastName) !== null && _contact_lastName !== void 0 ? _contact_lastName : ''
    } : {
        firstName: (_contact_name = contact.name) !== null && _contact_name !== void 0 ? _contact_name : '',
        lastName: ''
    };
    var _contact_phoneNumbers__number;
    return _object_spread_props(_object_spread({}, nameFields), {
        ID: contact.id,
        phone: (_contact_phoneNumbers__number = (_contact_phoneNumbers = contact.phoneNumbers) === null || _contact_phoneNumbers === void 0 ? void 0 : (_contact_phoneNumbers_ = _contact_phoneNumbers[0]) === null || _contact_phoneNumbers_ === void 0 ? void 0 : _contact_phoneNumbers_.number) !== null && _contact_phoneNumbers__number !== void 0 ? _contact_phoneNumbers__number : '',
        localDeviceID: contact.id,
        imageBase64: '',
        imageAssetKey: ''
    });
}
export function transformExpoContactToResponseContact(contact) {
    var _contact_phoneNumbers_, _contact_phoneNumbers, _contact_emails_map, _contact_emails, _contact_image;
    var hasNameParts = !!(contact.firstName || contact.lastName);
    var nameFields = hasNameParts ? {
        name_first: contact.firstName,
        name_last: contact.lastName
    } : {
        name_first: contact.name
    };
    var value = _object_spread_props(_object_spread({}, nameFields), {
        id: contact.id,
        phone: (_contact_phoneNumbers = contact.phoneNumbers) === null || _contact_phoneNumbers === void 0 ? void 0 : (_contact_phoneNumbers_ = _contact_phoneNumbers[0]) === null || _contact_phoneNumbers_ === void 0 ? void 0 : _contact_phoneNumbers_.number,
        email: (_contact_emails = contact.emails) === null || _contact_emails === void 0 ? void 0 : (_contact_emails_map = _contact_emails.map(function(e) {
            return e.email;
        })) === null || _contact_emails_map === void 0 ? void 0 : _contact_emails_map[0]
    });
    if ((_contact_image = contact.image) === null || _contact_image === void 0 ? void 0 : _contact_image.base64) {
        var _contact_image1;
        value.imageBase64 = (_contact_image1 = contact.image) === null || _contact_image1 === void 0 ? void 0 : _contact_image1.base64;
    }
    return value;
}
export function transformExpoContactToApiContact(contact) {
    var _contact_emails, _contact_phoneNumbers, _contact_image;
    var hasNameParts = !!(contact.firstName || contact.lastName);
    var _contact_emails_map, _contact_firstName, _contact_lastName, _contact_name, _contact_phoneNumbers_map;
    return {
        email: (_contact_emails_map = (_contact_emails = contact.emails) === null || _contact_emails === void 0 ? void 0 : _contact_emails.map(function(e) {
            return e.email;
        })) !== null && _contact_emails_map !== void 0 ? _contact_emails_map : null,
        name: hasNameParts ? {
            first: (_contact_firstName = contact.firstName) !== null && _contact_firstName !== void 0 ? _contact_firstName : null,
            last: (_contact_lastName = contact.lastName) !== null && _contact_lastName !== void 0 ? _contact_lastName : null,
            nick: null
        } : {
            first: (_contact_name = contact.name) !== null && _contact_name !== void 0 ? _contact_name : null,
            last: null,
            nick: null
        },
        phone: (_contact_phoneNumbers_map = (_contact_phoneNumbers = contact.phoneNumbers) === null || _contact_phoneNumbers === void 0 ? void 0 : _contact_phoneNumbers.map(function(p) {
            return p.number;
        })) !== null && _contact_phoneNumbers_map !== void 0 ? _contact_phoneNumbers_map : null,
        image: ((_contact_image = contact.image) === null || _contact_image === void 0 ? void 0 : _contact_image.base64) ? {
            url: null,
            data: contact.image.base64
        } : null
    };
}
export function transformApiContactToResponseContact(contact) {
    var _contact_email, _contact_phone, _contact_image;
    var transformed = {
        name_first: contact.name.first,
        name_last: contact.name.last
    };
    if ((_contact_email = contact.email) === null || _contact_email === void 0 ? void 0 : _contact_email[0]) {
        transformed.email = contact.email[0];
    }
    if ((_contact_phone = contact.phone) === null || _contact_phone === void 0 ? void 0 : _contact_phone[0]) {
        transformed.phone = contact.phone[0];
    }
    if ((_contact_image = contact.image) === null || _contact_image === void 0 ? void 0 : _contact_image.data) {
        var _contact_image1;
        transformed.imageBase64 = contact === null || contact === void 0 ? void 0 : (_contact_image1 = contact.image) === null || _contact_image1 === void 0 ? void 0 : _contact_image1.data;
    }
    return transformed;
}
